import {get, post} from '@/utils/http'

/**
 * Create a new iOS profile session with temp token
 * @returns {Promise<{tempToken: string, downloadUrl: string}>}
 */
async function createProfileSession() {
    return await post('/ios/profile/create', {frontendUrl: location.href}, 'application/x-www-form-urlencoded');
}

/**
 * Get temp token status and device info if received
 * @param {string} tempToken
 * @returns {Promise<{tempToken: string, received: boolean, udid?: string, model?: string, productType?: string}>}
 */
async function getTempTokenStatus(tempToken) {
    return await get('/ios/udid/temp', { tempToken });
}

/**
 * Check if a device has a registered UDID
 * @param {string} deviceId
 * @returns {Promise<{deviceId: string, udidRegistered: boolean, udid?: string}>}
 */
async function getUdidStatus(deviceId) {
    return await get('/ios/udid/status', { deviceId });
}

/**
 * Bind a temp token to a real device ID
 * @param {string} tempToken
 * @param {string} deviceId
 * @returns {Promise<{success: boolean, deviceId: string, udid?: string, model?: string}>}
 */
async function bindTempTokenToDevice(tempToken, deviceId) {
    return await post('/ios/udid/bind', { tempToken, deviceId });
}

export default {
    createProfileSession,
    getTempTokenStatus,
    getUdidStatus,
    bindTempTokenToDevice
}
